import { useCodeDeck } from "Hooks/Endpoints";
import React, { Fragment, useState } from "react";
import {
  Breadcrumb,
  Button,
  Confirm,
  Container,
  Menu,
} from "semantic-ui-react";
import CreateCodeForm from "./CreateCodeForm";
import CodeForm from "./CodeForm";
import CodeDeckForm from "./CodeDeckForm";
import CodeDeckCodes from "./CodeDeckCodes";
import useCheckRole from "Hooks/APICheckRole";

const CodeDeckDetail = () => {
  const { hasRole, roles } = useCheckRole();
  const {
    codeDeck,
    code,
    unselect,
    unselectCode,
    cloneCodeDeck,
    remove,
    createCode,
  } = useCodeDeck();

  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const [confirmClone, setConfirmClone] = useState<boolean>(false);

  return (
    <Container fluid>
      {!code && (
        <Fragment>
          <Menu>
            <Menu.Item header>Billing</Menu.Item>
            <Menu.Item>
              <Breadcrumb>
                <Breadcrumb.Section link onClick={() => unselect()}>
                  Code Decks
                </Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section>{codeDeck.name}</Breadcrumb.Section>
              </Breadcrumb>
            </Menu.Item>
            <Menu.Menu position='right'>
              {hasRole(roles.billing.codes.roles.clone) && (
                <Menu.Item>
                  <Button
                    size='small'
                    secondary
                    onClick={() => setConfirmClone(true)}
                  >
                    Clone
                  </Button>
                </Menu.Item>
              )}
              {hasRole(roles.billing.codes.roles.delete) && (
                <Menu.Item>
                  <Button
                    size='tiny'
                    color='red'
                    onClick={() => setConfirmDelete(true)}
                  >
                    Delete
                  </Button>
                </Menu.Item>
              )}
            </Menu.Menu>
          </Menu>
          <div style={{ padding: "20px" }}>
            <CodeDeckForm />
            {!createCode && <CodeDeckCodes />}
            {createCode && <CreateCodeForm />}
          </div>
        </Fragment>
      )}
      {code && (
        <Fragment>
          <Menu>
            <Menu.Item header>Billing</Menu.Item>
            <Menu.Item>
              <Breadcrumb>
                <Breadcrumb.Section link onClick={() => unselect()}>
                  Code Decks
                </Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section link onClick={() => unselectCode()}>
                  {codeDeck.name}
                </Breadcrumb.Section>
              </Breadcrumb>
            </Menu.Item>
          </Menu>
          <CodeForm />
        </Fragment>
      )}
      <Confirm
        open={confirmClone}
        onCancel={() => setConfirmClone(false)}
        onConfirm={() => cloneCodeDeck()}
      />
      <Confirm
        open={confirmDelete}
        onCancel={() => setConfirmDelete(false)}
        onConfirm={() => remove(codeDeck.id)}
      />
    </Container>
  );
};

export default CodeDeckDetail;
